import { Heading } from '@/components/common/Heading';

interface IngredientPropertyProps {
  label: string;
  children: React.ReactNode;
}

export const IngredientProperty = ({
  label,
  children,
}: IngredientPropertyProps) => {
  return (
    <div className="flex flex-col gap-3">
      <Heading asChild size="h4" className="text-left">
        <p>{label}</p>
      </Heading>

      {children}
    </div>
  );
};
